import { Injectable } from '@angular/core';
import { faPerson, faPersonCircleCheck, faPersonCircleXmark, faComment, faFlag, faPalette, faBan, faLeftRight, faUserTieHair, faAddressBook, faHandshake, faLink, faEye, faEyeSlash,faReceipt,faArrowDown, faMobileScreen,faHouse,faPhoneOffice, 
  faMobile, faCopy, faXmark, faFile, faTrashCan, faArrowUp, faAt, faFileSignature, faRotateLeft, faCircleQuestion, faTasks, faCoffee, faComments, faFileText, faDesktop, 
  faBars, faUsers, faUser, faCheck, faCancel, faPhone, faEnvelope, faEarthAmericas, faTruck, faLocationDot, faPenToSquare, faArrowUpRightFromSquare, faCirclePlus, faCross, 
  faCircleXmark, faSidebarFlip, faArrowRightToBracket, faDeleteRight, faCircleCheck, faBrowser, faChevronDown, faPlus, faCircleX, faUpload, faMagnifyingGlass, 
  faUserMagnifyingGlass, faPlane, faPeopleArrows, faCircleDollarToSlot, faPuzzle, faQuestion, faTreePalm, faScrewdriverWrench, faWavePulse, faUserCheck, faBriefcase, 
  faClock, faCar, faPeopleRoof, faGear, faVanShuttle, faFileContract, faQrcode, faUserPlus, faUserSlash, faSearch, 
  faPoll,
  faRefresh,
  faFileCsv,
  faFilterSlash,
  faEllipsis,
  faCircleInfo,
  faDownload,
  faFloppyDisk,
  faHamburger,
  faChevronRight,
  faFileInvoiceDollar,
  faRotate,
  faTriangleExclamation,
  faPeopleGroup,
  faHandHoldingSeedling,
  faBadgeCheck,
  faPrint,
  faThumbsUp,
  faCalendar,
  faExclamationTriangle,
  faHandshakeSimple,
  faMinus,
  faCartShopping, faTags,
  faStar,
  faSpinner,
  faCrown,
  faBed,
  faAddressCard,
  faGlobe,
  faImage, faWifi,
  faMountainSun,
  faHandPointer,
  faCommentSms,
  faBorderAll,
  faFilm,
  faUserCircle,
  faRotateRight,
  faArrowLeft,
  faSun,
  faBolt,
  faIdBadge,
  faCamera,
  faLock, faClipboardUser, faCirclesOverlap, faBullseye, faWallet, faBallotCheck, faShirt, faBedBunk, faPollPeople, faFiles} from '@fortawesome/pro-solid-svg-icons'
import { faChevronRight as faChevronRightR, faLinkSlash, faCircleXmark as faCircleXmarkR, faEyeSlash as faEyeSlashR, faEye as faEyeR, faHandshake as faHandshakeR, faEnvelope as faEnvelopeR, 
  faComments as faCommentsR, faClock as faClockR, faCircleQuestion as faCircleQuestionR, faCircleMinus as faCircleMinusR, faCirclePlus as faCirclePlusR, 
  faCircleCheck as faCircleCheckR, faBrowser as faBrowserR, faChevronDown as faChevronDownR, faFileSpreadsheet, faPalette as faPaletteR, faCircleInfo as faCircleInfoR, faMemoCircleInfo, faHeartCircleCheck, faCircleLocationArrow, faSidebarFlip as faSidebarFlipR, faFiles as faFilesR } from '@fortawesome/pro-regular-svg-icons'
import { faStar as faStarLight, faHeartCircleExclamation } from '@fortawesome/pro-light-svg-icons'

import { faGoogleDrive } from "@fortawesome/free-brands-svg-icons"
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { icon } from '@fortawesome/fontawesome-svg-core'
import { DomSanitizer } from '@angular/platform-browser';
@Injectable({
  providedIn: 'root'
})
export class IconService {

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  get solid(): Record<string, IconDefinition> {
    return {
      faEllipsis: faEllipsis,
      faCircleInfo: faCircleInfo,
      faDownload: faDownload,
      faFloppyDisk: faFloppyDisk,
      faFilterSlash: faFilterSlash,
      faFileCsv: faFileCsv,
      faRefresh: faRefresh,
      faPoll: faPoll,
      faSearch: faSearch,
      faUserCheck: faUserCheck,
      faFlag: faFlag,
      faPalette: faPalette,
      faLinkSlash: faLinkSlash,
      faBan: faBan,
      faLeftRight: faLeftRight,
      faUserTieHair: faUserTieHair,
      faHandshake: faHandshake,
      faLink: faLink,
      faReceipt: faReceipt,
      faCopy: faCopy,
      faFile: faFile,
      faUsers: faUsers,
      faUser: faUser,
      faAt: faAt,
      faXmark: faXmark,
      faArrowUp: faArrowUp,
      faTrashCan: faTrashCan,
      faFileSignature: faFileSignature,
      faRotateLeft: faRotateLeft,
      faCheck: faCheck,
      faCancel: faCancel,
      faPhone: faPhone,
      faEnvelope: faEnvelope,
      faEarthAmericas: faEarthAmericas,
      faTruck: faTruck,
      faLocationDot: faLocationDot,
      faPenToSquare: faPenToSquare,
      faArrowUpRightFromSquare: faArrowUpRightFromSquare,
      faCirclePlus: faCirclePlus,
      faCross: faCross,
      faCircleXmark: faCircleXmark,
      faBars: faBars,
      faDesktop: faDesktop,
      faFileText: faFileText,
      faComments: faComments,
      faTasks: faTasks,
      faCoffee: faCoffee,
      faCircleQuestion: faCircleQuestion,
      faSidebarFlip: faSidebarFlip,
      faArrowRightToBracket: faArrowRightToBracket,
      faDeleteRight: faDeleteRight,
      faCircleCheck: faCircleCheck,
      faClipboardUser: faClipboardUser,
      faCirclesOverlap: faCirclesOverlap,
      faBullseye: faBullseye,
      faWallet: faWallet,
      faBallotCheck: faBallotCheck,
      faPlus: faPlus,
      faArrowDown: faArrowDown,
      faAddressBook: faAddressBook,
      faBriefcase: faBriefcase,
      faClock: faClock,
      faCar: faCar,
      faGear: faGear,
      faComment: faComment,
      faScrewdriverWrench: faScrewdriverWrench,
      faMobile: faMobile,
      faQuestion: faQuestion,
      faTreePalm: faTreePalm,
      faBrowser: faBrowser,
      faChevronDown: faChevronDown,
      faChevronRight: faChevronRight,
      faCircleX: faCircleX,
      faUpload: faUpload,
      faMagnifyingGlass: faMagnifyingGlass, 
      faUserMagnifyingGlass: faUserMagnifyingGlass,
      faPlane: faPlane,
      faPeopleArrows: faPeopleArrows,
      faCircleDollarToSlot: faCircleDollarToSlot,
      faPuzzle: faPuzzle,
      faWavePulse: faWavePulse,
      faPerson: faPerson,
      faPersonCircleCheck: faPersonCircleCheck,
      faPersonCircleXmark: faPersonCircleXmark,
      faGlobe: faGlobe,
      faAddressCard: faAddressCard,
      faPeopleGroup: faPeopleGroup,
      faHandHoldingSeedling: faHandHoldingSeedling,
      faBadgeCheck: faBadgeCheck,
      faPrint: faPrint,
      faThumbsUp: faThumbsUp,
      faCalendar: faCalendar,
      faExclamationTriangle: faExclamationTriangle,
      faHandshakeSimple: faHandshakeSimple,
      faMinus: faMinus,
      faTags: faTags,
      faCrown: faCrown,
      faBed: faBed,
      faHeartCircleCheck: faHeartCircleCheck,
      faImage: faImage,
      faWifi: faWifi,
      faCamera: faCamera,
      faLock: faLock,
      faMountainSun: faMountainSun,
      faHandPointer: faHandPointer,
      faCommentSms: faCommentSms,
      faBorderAll: faBorderAll,
      faFilm: faFilm,
      faUserCircle: faUserCircle,
      faRotateRight: faRotateRight,
      faArrowLeft: faArrowLeft,
      faSun: faSun,
      faBolt: faBolt,
      faIdBadge: faIdBadge,
      faShirt: faShirt,
      faBedBunk: faBedBunk,
      faPollPeople: faPollPeople,
      faFiles: faFiles,
    }
  }

  get regular(): Record<string, IconDefinition> {
    return {
      faEnvelope: faEnvelopeR,
      faComments: faCommentsR,
      faClock: faClockR,
      faCircleQuestion: faCircleQuestionR,
      faCircleMinus: faCircleMinusR,
      faCirclePlus: faCirclePlusR,
      faCircleCheck: faCircleCheckR,
      faHandshake: faHandshakeR,
      faEye: faEyeR,
      faEyeSlash: faEyeR,
      faBrowserR: faBrowserR,
      faFileSpreadsheet: faFileSpreadsheet,
      faPalette: faPaletteR,
      faCircleInfo: faCircleInfoR,
      faMemoCircleInfo: faMemoCircleInfo,
      faCircleLocationArrow: faCircleLocationArrow,
      faFiles: faFilesR
    }
  }

  get brands() {
    return {
      faGoogleDrive: faGoogleDrive
    }
  }

  get ppmRegular() {
    return {
      public: faEyeR,
      notPublic: faEyeSlashR,
      confirmed: faCircleCheckR,
      notConfirmed: faCircleXmarkR,
      rowMenu: faChevronDownR,
      rowMenuCollapsed: faChevronRightR,
      rowMenuExpanded: faChevronDownR
    }
  }

  get ppmLight() {
    return {
      favorite: faStarLight,
      ppm365MainContact: faHeartCircleExclamation
    }
  }

  get ppmSolid() {
    return {
      success: faCircleCheck,
      error: faCircleXmark,
      help: faCircleQuestion,
      info: faCircleInfo,
      clearFilter: faFilterSlash,
      csv: faFileCsv,
      formResponse: faPoll,
      public: faEye,
      notPublic: faEyeSlash,
      confirmed: faCircleCheck,
      notConfirmed: faCircleXmark,
      dataPad: faSidebarFlipR,
      delete: faCircleXmark,
      mobilePhone: faMobileScreen,
      homePhone: faHouse,
      officePhone: faPhoneOffice,
      otherPhone: faPhone,
      externalLink: faArrowUpRightFromSquare,
      edit: faPenToSquare,
      view: faEye,
      copy: faCopy,
      add: faCirclePlus,
      upload: faUpload,
      expand: faCirclePlus,
      fullTime: faBriefcase,
      partTime: faClock,
      driver: faCar,
      driverVan: faVanShuttle,
      ministryLeader: faPeopleRoof,
      sms: faComment,
      participantForms: faFileContract,
      qrCode: faQrcode,
      register: faUserPlus,
      inactiveUser: faUserSlash,
      contact: faAddressBook,
      receipt: faReceipt,
      download: faDownload,
      save: faFloppyDisk,
      menu: faBars,
      settings: faGear,
      rowExpandClosed: faChevronRight,
      rowExpandOpened: faChevronDown,
      expenseReport: faFileInvoiceDollar,
      sync: faRotate,
      warning: faTriangleExclamation,
      resetPassword: faRefresh,
      order: faCartShopping,
      favorite: faStar,
      loading: faSpinner,
      note: faPenToSquare
    }
  }

  getSvgString(iconDef: IconDefinition) {
    return icon(iconDef).html.join('')
  }

}
